function PaperClipIcon(props) {
  const { 
    className, 
    color= '#727580', 
    height= 14, 
    width=10
  } = props

  return (
    <svg 
        width={width}
        height={height}
        viewBox="0 0 10 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path 
            d="M10 9.625C10 10.8383 9.51333 11.8708 8.54 12.7225C7.56667 13.5742 6.38667 14 5 14C3.61333 14 2.43333 13.5742 1.46 12.7225C0.486667 11.8708 0 10.8383 0 9.625V3.15C0 2.275 0.35 1.53125 1.05 0.91875C1.75 0.30625 2.6 0 3.6 0C4.6 0 5.45 0.30625 6.15 0.91875C6.85 1.53125 7.2 2.275 7.2 3.15V9.275C7.2 9.81167 6.98667 10.2667 6.56 10.64C6.13333 11.0133 5.61333 11.2 5 11.2C4.38667 11.2 3.86667 11.0133 3.44 10.64C3.01333 10.2667 2.8 9.81167 2.8 9.275V3.5C2.8 3.30167 2.87667 3.13542 3.03 3.00125C3.18333 2.86708 3.37333 2.8 3.6 2.8C3.82667 2.8 4.01667 2.86708 4.17 3.00125C4.32333 3.13542 4.4 3.30167 4.4 3.5V9.275C4.4 9.42667 4.45667 9.55208 4.57 9.65125C4.68333 9.75042 4.82667 9.8 5 9.8C5.17333 9.8 5.31667 9.75042 5.43 9.65125C5.54333 9.55208 5.6 9.42667 5.6 9.275V3.15C5.58667 2.66 5.39 2.24583 5.01 1.9075C4.63 1.56917 4.16 1.4 3.6 1.4C3.04 1.4 2.56667 1.56917 2.18 1.9075C1.79333 2.24583 1.6 2.66 1.6 3.15V9.625C1.58667 10.4533 1.91333 11.1562 2.58 11.7338C3.24667 12.3112 4.05333 12.6 5 12.6C5.93333 12.6 6.72667 12.3112 7.38 11.7338C8.03333 11.1562 8.37333 10.4533 8.4 9.625V3.5C8.4 3.30167 8.47667 3.13542 8.63 3.00125C8.78333 2.86708 8.97333 2.8 9.2 2.8C9.42667 2.8 9.61667 2.86708 9.77 3.00125C9.92333 3.13542 10 3.30167 10 3.5V9.625Z" 
            fill={color}
        />
    </svg>

  );
}

export { PaperClipIcon };
